import slotSelectionExtendedPanel from './slotSelectionExtendedPanel';

export default slotSelectionExtendedPanel;
